class ActiveAction {
    constructor() {
        this._init()
    }

	_init() {
		document.querySelectorAll("[data-active-action]").forEach(el => this.bindAction(el))
	}

	bindAction(el) {
		el.addEventListener('click', (e) => {
			e.stopPropagation()
			el.classList.toggle(el.dataset.activeAction)
		})
		window.addEventListener('click', () => el.classList.remove(el.dataset.activeAction))
	}
}

export default ActiveAction